export default [{
  path: 'leaveDeviceListAdd',
  name: 'leaveDeviceListAdd',
  component: function component() {
    return import('@/views/leaveDevice/add');
  }
}, {
  path: 'leaveDeviceListMaintain',
  name: 'leaveDeviceListMaintain',
  component: function component() {
    return import('@/views/leaveDevice/list');
  }
}, {
  path: 'leaveDeviceListDelete',
  name: 'leaveDeviceListDelete',
  component: function component() {
    return import('@/views/leaveDevice/deleteLsit');
  }
}, {
  path: 'leaveSuccess',
  name: 'leaveSuccess',
  component: function component() {
    return import('@/views/leaveDevice/success');
  }
}, {
  path: 'leaveMaterialListAdd',
  name: 'leaveMaterialListAdd',
  component: function component() {
    return import('@/views/leaveMaterial/add');
  }
}, {
  path: 'leaveMaterialListMaintain',
  name: 'leaveMaterialListMaintain',
  component: function component() {
    return import('@/views/leaveMaterial/list');
  }
}, {
  path: 'leaveMaterialSuccess',
  name: 'leaveMaterialSuccess',
  component: function component() {
    return import('@/views/leaveMaterial/success');
  }
}, {
  path: 'leaveMaterialListDelete',
  name: 'leaveMaterialListDelete',
  component: function component() {
    return import('@/views/leaveMaterial/deleteLsit');
  }
}];